import React, { forwardRef } from 'react';
import { Button, ButtonProps } from '../ui/button';

export interface StyledButtonProps extends ButtonProps {
  title: string;
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
}

const StyledButton: React.FC<StyledButtonProps> = forwardRef(
  (
    { title, size, variant, icon = null, iconPosition = 'left', ...props },
    ref,
  ) => {
    return (
      <Button
        size={size ?? 'lg'}
        variant={variant ?? 'brand'}
        {...props}
        ref={ref as React.Ref<HTMLButtonElement>}
      >
        {iconPosition === 'left' && icon}
        {title !== '' && <span className="px-0.5">{title}</span>}
        {iconPosition === 'right' && icon}
      </Button>
    );
  },
);

export default StyledButton;
